<template>
  <div class="row">
    <label class="form-label"
      >Sobre a Propriedade<span class="text-danger">*</span>
    </label>

    <div style="display: flex; align-items: center">
      <label style="margin-right: 10px">
        <input
          type="radio"
          name="propriedade"
          value="Urbano"
          :checked="form.crud.form.propriedade === 'Urbano'"
          v-model="form.crud.form.propriedade"
          @change="clearProperty(form)"
        />
        Urbano
      </label>
      <label>
        <input
          type="radio"
          name="propriedade"
          style="margin-left: 10px"
          value="Rural"
          :checked="form.crud.form.propriedade === 'Rural'"
          v-model="form.crud.form.propriedade"
          @change="clearProperty(form)"
        />
        Rural
      </label>
    </div>

    <div class="mb-3 col-md-6 col-12">
      <label class="form-label"
        >Nome da Propriedade<span class="text-danger">*</span></label
      >
      <input type="text" class="form-control" v-model="form.crud.form.nome" />
      <Error v-if="form.crud.error" :error="form.crud.error.nome"></Error>
    </div>
    <div class="mb-3 col-md-6 col-12">
      <label class="form-label" v-if="form.crud.form.propriedade === 'Rural'"
        >Cultura <span class="text-danger">*</span></label
      >
      <VueMultiselect
        v-if="form.crud.form.propriedade === 'Rural'"
        style="z-index: 1000 !important"
        v-model="form.crud.form.culturaPropriedades"
        :options="taggingOptions"
        :multiple="true"
        :taggable="true"
        :show-labels="false"
        placeholder="Selecione"
        label="name"
        track-by="code"
      />
      <Error v-if="form.crud.error" :error="form.crud.error.culturaPropriedades"></Error>
    </div>
    <div class="mb-3 col-md-6 col-12">
      <label class="form-label"
        >Tipo de identificação</label
      >
      <SelectData
        v-if="form.crud.form.propriedade === 'Rural'"
        url="/PropriedadeAgricola/TypeIdentificationRural"
        field="nome"
        label="nome"
        empty="Selecione"
        :value="
          form.crud.form.tipoIdentificacao == undefined
            ? null
            : form.crud.form.tipoIdentificacao
        "
        @change="clearTypeOrganization(form)"
        @value="form.crud.form.tipoIdentificacao = $event"
      >
      </SelectData>

      <SelectData
        v-else
        url="/PropriedadeAgricola/TypeIdentificationUrban"
        field="nome"
        label="nome"
        empty="Selecione"
        :value="
          form.crud.form.tipoIdentificacao == undefined
            ? null
            : form.crud.form.tipoIdentificacao
        "
        @change="clearTypeOrganization(form)"
        @value="form.crud.form.tipoIdentificacao = $event"
      >
      </SelectData>
      <Error
        v-if="form.crud.error"
        :error="form.crud.error.tipoIdentificacao"
      ></Error>
    </div>

    <div class="mb-3 col-md-6 col-12">
      <label class="form-label"
        >Identificação</label
      >

      <input
        v-if="
          form.crud.form.tipoIdentificacao !== 'CPF' ||
          form.crud.form.tipoIdentificacao !== 'CNPJ'
        "
        type="text"
        class="form-control"
        onfocus="this.value=''"
        v-model="form.crud.form.identificacao"
      />

      <input
        v-if="form.crud.form.tipoIdentificacao == 'CNPJ'"
        type="text"
        class="form-control"
        onfocus="this.value=''"
        style="display: none"
        v-mask="'##.###.###/####-##'"
        v-model="form.crud.form.identificacao"
      />

      <input
        v-if="form.crud.form.tipoIdentificacao == 'CPF'"
        type="text"
        class="form-control"
        onfocus="this.value=''"
        style="display: none"
        v-mask="'###.###.###-##'"
        v-model="form.crud.form.identificacao"
      />

      <Error
        v-if="form.crud.error"
        :error="form.crud.error.identificacao"
      ></Error>
    </div>
    <div class="mb-3 col-md-6 col-12" v-if="form.crud.form.propriedade != null">
      <label class="form-label"
        >Tipo de organização
      </label>
      <VueMultiselect
        style="z-index: 100 !important"
        v-model="form.crud.form.tipoOrganizacao"
        v-if="
          form.crud.form.propriedade == 'Urbano' &&
          form.crud.form.tipoIdentificacao != 'CNPJ' &&
          form.crud.form.tipoIdentificacao != 'CPF'
        "
        :options="optionsUrbana"
        :show-labels="false"
        placeholder="Selecione"
      />

      <VueMultiselect
        style="z-index: 100 !important"
        v-model="form.crud.form.tipoOrganizacao"
        v-if="
          form.crud.form.propriedade == 'Rural' &&
          form.crud.form.tipoIdentificacao != 'CNPJ' &&
          form.crud.form.tipoIdentificacao != 'CPF'
        "
        :options="optionsRural"
        :show-labels="false"
        placeholder="Selecione"
      />
      <VueMultiselect
        style="z-index: 100 !important"
        v-model="form.crud.form.tipoOrganizacao"
        v-if="
          form.crud.form.tipoIdentificacao == 'CNPJ' &&
          form.crud.form.propriedade == 'Urbano'
        "
        :options="optionsUrbanaCNPJ"
        :show-labels="false"
        placeholder="Selecione"
      />
      <VueMultiselect
        style="z-index: 100 !important"
        v-model="form.crud.form.tipoOrganizacao"
        v-if="
          form.crud.form.tipoIdentificacao == 'CNPJ' &&
          form.crud.form.propriedade == 'Rural'
        "
        :options="optionsRural"
        :show-labels="false"
        placeholder="Selecione"
      />
      <VueMultiselect
        style="z-index: 100 !important"
        v-model="form.crud.form.tipoOrganizacao"
        v-if="
          form.crud.form.tipoIdentificacao == 'CPF' &&
          form.crud.form.propriedade == 'Urbano'
        "
        :options="optionsUrbanaCPF"
        :show-labels="false"
        placeholder="Selecione"
      />
      <VueMultiselect
        style="z-index: 100 !important"
        v-model="form.crud.form.tipoOrganizacao"
        v-if="
          form.crud.form.tipoIdentificacao == 'CPF' &&
          form.crud.form.propriedade == 'Rural'
        "
        :options="optionsRural"
        :show-labels="false"
        placeholder="Selecione"
      />
      <Error
        v-if="form.crud.error"
        :error="form.crud.error.tipoOrganizacao"
      ></Error>
    </div>
    <div
      v-show="form.crud.form.tipoOrganizacao === 'Outros'"
      class="mb-3 col-md-6 col-12"
    >
      <label class="form-label">Outros<span class="text-danger">*</span></label>
      <input type="text" class="form-control" v-model="form.crud.form.outros" />
      <Error v-if="form.crud.error" :error="form.crud.error.nome"></Error>
    </div>
    <label class="form-label"
      >Endereço Completo<span class="text-danger">*</span></label
    >
    <div class="mb-3 col-md-6 col-12">
      <label class="form-label">CEP <span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control"
        v-mask="'#####-###'"
        v-model="form.crud.form.cep"
      />
      <Error v-if="form.crud.error" :error="form.crud.error.cep"></Error>
    </div>
    <div class="mb-3 col-md-6 col-12">
      <label class="form-label">UF <span class="text-danger">*</span></label>
      <input type="text" class="form-control" v-model="form.crud.form.uf" />
      <Error v-if="form.crud.error" :error="form.crud.error.uf"></Error>
    </div>
    <div class="mb-3 col-md-6 col-12">
      <label class="form-label"
        >Municipio <span class="text-danger">*</span></label
      >
      <input
        type="text"
        class="form-control"
        v-model="form.crud.form.municipio"
      />
      <Error v-if="form.crud.error" :error="form.crud.error.municipio"></Error>
    </div>
    <div class="mb-3 col-md-6 col-12">
      <label class="form-label"
        >Endereço <span class="text-danger">*</span></label
      >
      <input
        type="text"
        class="form-control"
        v-model="form.crud.form.logradouro"
      />
      <Error v-if="form.crud.error" :error="form.crud.error.logradouro"></Error>
    </div>
    <div class="mb-3 col-md-6 col-12">
      <label class="form-label"
        >Bairro <span class="text-danger">*</span></label
      >
      <input type="text" class="form-control" v-model="form.crud.form.bairro" />
      <Error v-if="form.crud.error" :error="form.crud.error.bairro"></Error>
    </div>
    <div class="mb-3 col-md-12 col-12">
      <label class="form-label">Localizações (Pins) <span class="text-danger">*</span></label>
      <MultipleLocationsManager
        ref="locationsManager"
        v-model="form.crud.form.locais"
        @input="onLocaisInput"
      ></MultipleLocationsManager>
      <Error v-if="form.crud.error" :error="form.crud.error.locais"></Error>
    </div>

    <div class="mb-3 col-12 col-md-6" v-if="form.crud.form.created">
      <label class="form-label">Criado</label>
      <input
        type="datetime-local"
        class="form-control"
        readonly
        :value="form.crud.form.created"
      />
    </div>
    <div class="mb-3 col-12 col-md-6" v-if="form.crud.form.updated">
      <label class="form-label">Atualizado</label>
      <input
        type="datetime-local"
        class="form-control"
        readonly
        :value="form.crud.form.updated"
      />
    </div>
  </div>
  <Alert ref="alert"></Alert>
</template>
<script>
import Error from "../../components/Error.vue";
import Alert from "../../components/Alert.vue";
import SelectData from "../../components/crud/input/SelectData.vue";
import MultipleLocationsManager from "../../components/MultipleLocationsManager.vue";
import VueMultiselect from "vue-multiselect";
import { mask } from "vue-the-mask";

export default {
  props: ["form"],
  directives: { mask },
  components: {
    Error,
    Alert,
    SelectData,
    MultipleLocationsManager,
    VueMultiselect,
  },

  data() {
    return {
      locationsKey: 0,
      taggingSelected: null,
      taggingOptions: [
        { name: "Leite", code: "LEITE" },
        { name: "Suíno Cultura", code: "SUINOCULTURA" },
        { name: "Viticultura (Uva)", code: "VITICULTURA" },
        { name: "Trigo", code: "TRIGO" },
        { name: "Soja", code: "SOJA" },
        { name: "Fumicultura", code: "FUMICULTURA" },
        { name: "Bovino Cultura", code: "BOVINOCULTURA" },
        { name: "Equino Cultura", code: "EQUINOCULTURA" },
        { name: "Citrus", code: "CITRUS" },
        { name: "Vegetais", code: "VEGETAIS" },
        { name: "Milho", code: "MILHO" },
        { name: "Outro", code: "OUTRO" },
      ],
      selected: null,
      optionsRural: [
        "Produtor Rural",
        "Cooperativa",
        "Agroindustria",
        "Grupo Agrícola",
        "Industria de alimentos e bebidas",
        "Instituição de pesquisa",
        "Consultor",
        "Revenda",
        "Outros",
      ],
      optionsUrbana: ["Físico", "Jurídico", "Público"],
      optionsUrbanaCNPJ: ["Jurídico", "Público"],
      optionsUrbanaCPF: ["Físico"],
    };
  },
  mounted() {
    // Adiciona evento de foco para manter o campo visível no mobile
    if (window.innerWidth <= 768) {
      this.$nextTick(() => {
        if (this.$el && typeof this.$el.querySelectorAll === 'function') {
          const inputs = this.$el.querySelectorAll('input.form-control');
          inputs.forEach(input => {
            input.addEventListener('focus', this.scrollToInput);
          });
        }
      });
    }
  },
  beforeUnmount() {
    // Remove os event listeners ao destruir o componente
    if (window.innerWidth <= 768) {
      if (this.$el && typeof this.$el.querySelectorAll === 'function') {
        const inputs = this.$el.querySelectorAll('input.form-control');
        inputs.forEach(input => {
          input.removeEventListener('focus', this.scrollToInput);
        });
      }
    }
  },
  methods: {
    scrollToInput(event) {
      // Aguarda o teclado abrir (300ms) e depois faz scroll suave para o campo
      setTimeout(() => {
        const element = event.target;
        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);

        window.scrollTo({
          top: middle,
          behavior: 'smooth'
        });
      }, 300);
    },
    clearProperty(form) {
      form.crud.form.culturaPropriedades = [];
      form.crud.form.tipoOrganizacao = null;
    },
    clearTypeOrganization(form) {
      form.crud.form.tipoOrganizacao = null;
    },
    onLocaisInput(locais) {
      // Verificar se é um evento DOM ou o array de locais
      if (locais && locais.isTrusted !== undefined) {
        return; // Ignorar eventos DOM
      }
      // Atualizar apenas se for um array válido
      if (Array.isArray(locais)) {
        this.form.crud.form.locais = JSON.parse(JSON.stringify(locais));
      }
    },
    forceLocationsUpdate(locais) {
      // Método público para forçar atualização do MultipleLocationsManager
      if (this.$refs.locationsManager && locais && locais.length > 0) {
        // Atualizar diretamente o componente filho
        this.$refs.locationsManager.locations = JSON.parse(JSON.stringify(locais));
        this.$nextTick(() => {
          this.$refs.locationsManager.updateMapMarkers();

          // Centralizar o mapa no pin principal
          const principalLocation = locais.find(l => l.principal) || locais[0];
          if (principalLocation && this.$refs.locationsManager.$refs.mainMap) {
            this.$refs.locationsManager.$refs.mainMap.move(
              principalLocation.latitude,
              principalLocation.longitude,
              13
            );
          }
        });
      }
    },
    validateBeforeSave() {
      // Validar os pins de localização
      if (this.$refs.locationsManager) {
        const validation = this.$refs.locationsManager.validate();
        if (!validation.isValid) {
          this.$refs.alert.show(
            "Validação de Pins",
            validation.message,
            null,
            5000,
            "bg-warning"
          );
          return false;
        }
      }
      return true;
    },
  },
};
</script>
<style>
/* Previne scroll indesejado quando o teclado abre no mobile */
@media (max-width: 768px) {
  input.form-control,
  .multiselect__input {
    scroll-margin-top: 20px;
    scroll-margin-bottom: 100px;
  }
}

/*input[type="radio"] {
  appearance: none;
  border: 1px solid #d3d3d3;
  width: 15px;
  height: 15px;
  content: none;
  outline: none;
  margin: 0;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

input[type="radio"]:checked {
  appearance: none;
  outline: none;
  padding: 0;
  content: none;
  border: none;
}

input[type="radio"]:checked::before {
  position: relative;
  color: green !important;
  content: "\00A0\2713\00A0" !important;
  font-weight: bolder;
  font-size: 12px;
  bottom: 20%;
  transform: translate(-50%, -50%);
}*/
</style>
